import React, { useState } from 'react'
import {Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';


function Notification(props) {
var state = props.message == "" ? false : true;
const [modalShow, setModalShow] = useState(true);

  return (
    <div>        
     {/* Notification Modal */}
    <div>
  <Modal show={modalShow} aria-labelledby="contained-modal-title-vcenter" centered>
  
  {/* <ModalHeader style={{ padding: '11px 21px' }}>
      Notification

      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"> 
          <i className="fas fa-times" style={{ 
            color: '#0000004f',
            // border: '1px solid #0000000d',
            padding: '6px',
            // boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            borderRadius: '50%' }}></i> </span>
        </button>

    </ModalHeader> */}


    <ModalBody style={{ color: '#758698' }}>
            {/* {props.message} */}


            Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
            when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
            It has survived not only five centuries, but also the leap into electronic typesetting, remaining 
            essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets 
            containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus 
            PageMaker including versions of Lorem Ipsum.


    </ModalBody>


    {/* <ModalFooter>
      <div style={{ float: "left" }}> <img src='/dashboard/images/notification.png' width='30px' /> </div>
 
      <Button className='btn-sm' style={{ float: "right" }} onClick={() => setModalShow(false)}>
        Okay
      </Button>
    </ModalFooter> */}
  </Modal>
</div>

    </div>
  )
}

export default Notification;